import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import format from '../../helpers/format'
import {
  Link,
} from '../../components'

const Styles = require('./PlanScorecardNameHeader.css')

@CSSModules(Styles, {allowMultiple:true})
export default class PlanScorecardNameHeader extends Component {
  static propTypes = {
    planData: PropTypes.object
  }
  constructor(props) {
    super(props)
  }

  render() {
    if (!this.props.planData) { return null }
    const { planData } = this.props

    let hasPrimaryPlanLogo = false
    let primaryPlanLogo = null
    try {
      primaryPlanLogo = require('../../../static/images/plans/'+planData.path+'.png')
      hasPrimaryPlanLogo = true
    }
    catch (e) {
      console.log('')
    }

    // let hasSecondaryPlanLogos = false
    // const secondaryPlanLogos = []
    // if (planData.secondary_plan_logos && planData.secondary_plan_logos.length>0) {
    //   for (let i=0; i<planData.secondary_plan_logos.length; i++){
    //     try {
    //       const thisSecondaryLogo = require('../../../static/images/plans/'+planData.secondary_plan_logos[i][0]+'.png')
    //       secondaryPlanLogos.push([thisSecondaryLogo, planData.secondary_plan_logos[i][1]])
    //       hasSecondaryPlanLogos = true
    //     }
    //     catch (e) {
    //       console.log('')
    //     }
    //   }
    // }

    let hasDefaultFundManagerLogo = false
    let defaultFundManagerLogo = null
    try {
      defaultFundManagerLogo = require('../../../static/images/fam/'+planData.default_fund_manager_path+'.png')
      hasDefaultFundManagerLogo = true
    }
    catch (e) {
      console.log('')
    }

    const defaultFundSeriesFund = config.planOptionsSource[planData.rated_as_option[0][0]]
    const sStrategy = format.sanitize(defaultFundSeriesFund.strategy_name)
    const defaultFundSeriesUrl = config.routes.targetDateFunds + '/' + sStrategy

    //
    return (
      <div styleName='name-flex'>
        <div>
          <div styleName='name-label-logo'>
            {
              hasPrimaryPlanLogo ?
                (
                  <img
                    styleName='name-logo'
                    src={primaryPlanLogo}
                    alt={planData.short_name}
                  />
                ) :
                null
            }

          </div>
          <h2 styleName='name'>
            { planData.primary_plan_name }
          </h2>
        </div>
        <div>
          {
            hasDefaultFundManagerLogo ?
              (
                <div styleName='plan-details-lede-img-wrap'>
                  <Link
                    to={defaultFundSeriesUrl}
                    title={sStrategy}
                  >
                    <img
                      src={defaultFundManagerLogo}
                      alt={
                        'Default fund option managed by ' +
                          planData.default_fund_manager
                      }
                      styleName='plan-details-lede-img'
                    />
                  </Link>
                </div>
              ) :
              null
          }
          <div styleName='name-label'>
            <b>Target date</b> {planData.default_fund_name}
          </div>
          {
            planData.plan_names.length > 1 ?
              (
                <div styleName='other-plan-names-label'>
                  <b>Other plan names</b> {
                    planData.plan_names.map((e,i)=>{
                      return (
                        <span key={'plannames-'+i}>
                          {e}{i<planData.plan_names.length-1?', ':''}
                        </span>
                      )
                    })
                  }
                </div>
              ) :
              null
          }
          { /*
            hasSecondaryPlanLogos ?
              (
                <div styleName='secondary-plan-logo-wrap'>
                  {
                    secondaryPlanLogos.map((e, i) => {
                      return (
                        <img
                          src={e[0]}
                          alt={e[1]}
                          styleName='secondary-plan-logo'
                        />
                      )
                    })
                  }
                </div>
              ) :
              null
          */ }
          <div styleName='name-label'>
            <b>Plan data</b> {planData.year}
            {
              planData.filing_received ?
                <span>
                  &nbsp;(Filed {planData.filing_received})
                </span>:
                null
            }
          </div>
          <div styleName='name-label'>
            <b>Fund data last updated</b> {config.versionDate}
          </div>
        </div>
      </div>
    )
  }
}